// src/theme/tablestyles.js

/* =========================================================
   BRAND SURFACE BORDER (SINGLE SOURCE OF TRUTH)
   ========================================================= */

const BRAND_SURFACE_BORDER = {
  border: "2px solid #00336C", // BRAND BLUE
  borderRadius: 3,
  boxShadow: "0 4px 14px rgba(0, 51, 108, 0.12)",
  background: "linear-gradient(180deg, rgba(231,240,218,0.25) 0%, #ffffff 80%)",
};

/* =========================================================
   TABLE CELL STYLES
   ========================================================= */

export const TABLE_STYLES = {
  headerCell: {
    fontSize: "1rem",
    fontWeight: 700,
    color: "#00336C", // BRAND GREEN
    backgroundColor: "#F5F5F5",
    whiteSpace: "nowrap",
    textAlign: "center",
    verticalAlign: "middle",
  },

  bodyCell: {
    fontSize: "1rem",
    fontWeight: 500,
    color: "#00336C", // BRAND BLUE
    whiteSpace: "nowrap",
    textAlign: "center",
    verticalAlign: "middle",
  },

  // 🔹 PRIMARY clickable text
  clickableCell: {
    textTransform: "none",
    fontSize: "1rem",
    fontWeight: 600,
    color: "#00336C",
    p: 0,
    minWidth: 0,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    justifyContent: "center",
    textAlign: "center",

    "&:hover": {
      backgroundColor: "transparent",
      textDecoration: "underline",
    },
  },

  // 🔹 SECONDARY clickable text
  clickableSubCell: {
    textTransform: "none",
    fontSize: "0.875rem",
    fontWeight: 500,
    color: "#00336C",
    p: 0,
    minWidth: 0,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    justifyContent: "center",
    textAlign: "center",

    "&:hover": {
      backgroundColor: "transparent",
      textDecoration: "underline",
    },
  },
};

/* =========================================================
   ICON NORMALIZATION (BASE)
   ========================================================= */

export const TABLE_ICON_SX = {
  fontSize: 22,
  verticalAlign: "middle",
};

/* =========================================================
   ICON COLOR VARIANTS
   ========================================================= */

export const TABLE_ICON_BLUE_SX = {
  ...TABLE_ICON_SX,
  color: "#00336C",
  fontSize: 34,
};

export const TABLE_ICON_GREEN_SX = {
  ...TABLE_ICON_SX,
  color: "#648315",
  fontSize: 34,
};

export const TABLE_EXPLORE_MENU_ITEM_SX = {
  color: "#00336C",
  fontWeight: 600,

  "& .MuiListItemText-primary": {
    color: "#00336C",
    fontWeight: 600,
  },

  "&:hover, &:focus, &:active": {
    color: "#00336C",
    backgroundColor: "rgba(0, 51, 108, 0.06)",
  },

  "&.Mui-disabled": {
    color: "#00336C",
    opacity: 0.45,
  },
};

/* =========================================================
   INLINE ICON + TEXT
   ========================================================= */

export const TABLE_ICON_INLINE = {
  display: "inline-flex",
  alignItems: "center",
  gap: 0.5,
  justifyContent: "center",
};

/* =========================================================
   TABLE CONTAINER (USES BRAND BORDER)
   ========================================================= */

export const TABLE_CONTAINER = {
  ...BRAND_SURFACE_BORDER,

  overflowX: "auto",
  overflowY: "hidden",
  maxWidth: "100%",

  "& table": {
    width: "100%",
    tableLayout: "auto",
    minWidth: 1600,
  },
};

/* =========================================================
   TABLE ROW HOVER + STRIPE BEHAVIOR
   ========================================================= */

export const TABLE_ROW_HOVER_SX = {
  "&:nth-of-type(odd)": {
    backgroundColor: "#fafafa",
  },

  "&:hover": {
    backgroundColor: "rgba(0,51,108,0.05)",
  },

  borderLeft: "4px solid transparent",
  transition: "background-color 0.15s ease, border-left 0.15s ease",

  "&:hover td:first-of-type": {
    borderLeft: "4px solid #648315", // BRAND GREEN
  },
};
